var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCustomer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "34.83 31.939 19.239 23.983",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6534 37.1856C40.6649 39.2595 42.3544 40.9328 44.4271 40.9225C46.5022 40.911 48.1744 39.2226 48.1641 37.1487C48.1549 35.0737 46.4642 33.4014 44.3903 33.4118C42.3164 33.421 40.643 35.1117 40.6534 37.1856Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7542 54.4917C52.7322 49.2322 49.0159 44.9877 44.4544 45.0142C39.8929 45.0406 36.2135 49.3265 36.2354 54.5861L52.7542 54.4917Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCustomer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Customer.4eaa2c57.svg";
export { ForwardRef as ReactComponent };